export class ImportError {
  constructor(
    public row: number,
    public column: string,
    public message: string,
    public severity: 'error' | 'warning' = 'error',
    public code?: string
  ) {}

  static fromApiError(apiError: any, row: number): ImportError {
    return new ImportError(
      row,
      apiError.field || apiError.column || 'general',
      apiError.message || 'Error desconocido',
      apiError.severity || 'error',
      apiError.code
    );
  }

  toString(): string {
    return `Fila ${this.row + 1}, ${this.column}: ${this.message}`;
  }
}

export class ImportErrorCollection {
  private errors: ImportError[] = [];

  addError(error: ImportError): void {
    this.errors.push(error);
  }

  addErrors(errors: ImportError[]): void {
    this.errors.push(...errors);
  }

  getErrors(): ImportError[] {
    return this.errors;
  }

  getErrorsForRow(row: number): ImportError[] {
    return this.errors.filter(error => error.row === row);
  }

  getErrorsForColumn(column: string): ImportError[] {
    return this.errors.filter(error => error.column === column);
  }

  getErrorsForCell(row: number, column: string): ImportError[] {
    return this.errors.filter(error => error.row === row && error.column === column);
  }

  getTotalErrors(): number {
    return this.errors.length;
  }

  getErrorsByType(): { errors: ImportError[]; warnings: ImportError[] } {
    return {
      errors: this.errors.filter(e => e.severity === 'error'),
      warnings: this.errors.filter(e => e.severity === 'warning'),
    };
  }

  clear(): void {
    this.errors = [];
  }

  hasErrors(): boolean {
    return this.errors.some(e => e.severity === 'error');
  }

  hasWarnings(): boolean {
    return this.errors.some(e => e.severity === 'warning');
  }
}
